export enum RemoteConfigKey {
  cookieConsentConfig = 'cookieConsentConfig',
}
